<template>
    <div>
        <LoadingIndicator v-if="loading" />
        <h2 v-if="!loading && title && content.length > 0" class="tagged-news__title--blue">
            {{ title }}
        </h2>
        <div class="news-block__container">
            <div class="news-block__section news-block__section--left" v-if="!loading && !error && content.length > 0">
                <template v-for="(item, index) in sorted.left" :key="`left-${index}`">
                    <InsightsBlock :disableNavigationOnClick="item.disableNavigationOnClick"
                        :disableGradientOverlay="item.disableGradientOverlay" :hideDate="hideDate" :url="item.url"
                        :image="item.featuredImageUrl" :title="item.title" :category="item.category" :type="item.type"
                        :published="item.published" :featuredImageUrl="item.featuredImageUrl"
                        :podcast-embed-url="item.podcastEmbedUrl" :video-embed-url="item.videoEmbedUrl" />
                </template>
            </div>
            <div class="news-block__section news-block__section--right" v-if="!loading && !error && content.length > 0">
                <template v-for="(item, index) in sorted.right" :key="`right-${index}`">
                    <InsightsBlock :disableNavigationOnClick="item.disableNavigationOnClick"
                        :disableGradientOverlay="item.disableGradientOverlay" :hideDate="hideDate" :url="item.url"
                        :image="item.featuredImageUrl" :title="item.title" :category="item.category" :type="item.type"
                        :published="item.published" :featuredImageUrl="item.featuredImageUrl"
                        :podcast-embed-url="item.podcastEmbedUrl" :video-embed-url="item.videoEmbedUrl" />
                </template>
            </div>
        </div>
        <div class="news-block__grid">
            <div class="news-block__grid-wrapper">
                <a v-for="(article, index) in sorted.all" :key="index + '-regular'" :href="article.url"
                    class="news-block__grid-item">
                    <div class="news-block__grid-meta" v-if="!hideDate"><span>{{ article.published }}</span></div>
                    <h3 class="news-block__grid-title">{{ article.title }}</h3>
                </a>
            </div>
        </div>
        <div class="news-block__button" v-if="action || ShowSeeMore">
            <a v-if="action" :href="action.Url" :target="action.Target" class="button">{{ action.Name }}</a>
            <button v-if="ShowSeeMore && !noMoreContent" @click="loadMore" :disabled="loadingMore" class="button">{{
                loadingMore ? "Loading..." : SeeMoreLabel }}</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from '../Global/LoadingIndicator';
import InsightsBlock from "../Insights/InsightsBlock.vue"


export default {
    props: ["title", "tags", "culture", "category", "contentChildren", "action", "hideDate", "ShowSeeMore", "SeeMorePerPage", "SeeMoreLabel"],
    components: {
        LoadingIndicator,
        InsightsBlock
    },
    data() {
        return {
            error: false,
            loading: true,
            loadingMore: true,
            noMoreContent: false,
            content: [],
            skip: 0,
            take: 5,
            sorted: {
                left: [],
                right: [],
                all: [],
            },
        }
    },
    mounted() {
        this.getRelatedContent();
    },
    methods: {
        loadMore: function () {
            this.skip = this.sorted.left.length + this.sorted.right.length + this.sorted.all.length;
            this.take = this.SeeMorePerPage ?? 20;
            this.getRelatedContent();
        },
        sortContent: function () {
            this.sorted = {
                left: [],
                right: [],
                all: [],
            };
            let left = [];
            let right = [];
            let all = [];
            this.content.forEach((item, index) => {
                if (index < 2) {
                    left.push(item);
                } else if (index < 5) {
                    right.push(item);
                } else {
                    all.push(item);
                }
            });
            this.sorted.left = left;
            this.sorted.right = right;
            this.sorted.all = all;
        },
        getRelatedContent: function () {
            this.loadingMore = true;
            axios.post(`/api/related-content/tags-relationships?skip=${this.skip}&take=${this.take}&current=${parseInt(window.OMM.AssignedContentItem) ?? 0}&culture=${this.culture}`, {
                tags: this.tags,
                category: this.category,
                content: this.contentChildren,
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            })
                .then((response) => {
                    let self = this;
                    if (response.data.content.length < this.take) {
                        this.noMoreContent = true;
                    }
                    response.data.content.forEach((article) => {
                        self.content.push(article)
                    });
                    this.sortContent();
                    this.loading = false;
                    this.loadingMore = false;
                })
                .catch((err) => {
                    this.error = true;
                    this.loading = false;
                    this.loadingMore = false;
                });
        }
    }
}
</script>

